import React from 'react';
import { useAppStore } from '../../store';
import { LoadingSpinner } from '../ui/LoadingSpinner';

/**
 * Blocks the SPA until Clerk has loaded and the auth bridge has finished its first profile pass (or test mode).
 */
export const AuthPendingShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isAuthPending = useAppStore((s) => s.isAuthPending);
  if (import.meta.env.MODE === 'test') {
    return <>{children}</>;
  }
  if (isAuthPending) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 dark:bg-slate-950">
        <LoadingSpinner size="lg" />
      </div>
    );
  }
  return <>{children}</>;
};
